import React from 'react'

import ProgressBar from 'react-bootstrap/ProgressBar';
 

function BlockThree() {
    
    return (
     <div>
            <div class="row ketvirtasblokas sonai">
            <div className="col-12 pav1 text-center text-dark"> <p> PROGRAMINĖS ĮRANGOS IR TECHNOLOGIJŲ ĮGŪDŽIAI</p></div>
            <div className="col-12"> <hr className="text-white-50"/></div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4">
            <p className="pb-4 font-weight-bold">Turinio valdymo sistemos</p>
            <ProgressBar variant="success" now={40} /> <p>Prestashop</p>
            <ProgressBar variant="success" now={80} />  <p>Moodle</p>
            <ProgressBar variant="success" now={40} /> <p>Open Journal Systems</p>
            <ProgressBar variant="success" now={60} /> <p>Wordpress</p>
      </div>

      <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4">
            <p className="pb-4 font-weight-bold">Programavimo kalbos</p>
            <ProgressBar variant="info" now={45} /><p>Visual Basic</p>
            <ProgressBar variant="info" now={30} /> <p>Java</p>
            <ProgressBar variant="info" now={15} />  <p>C++</p>
            <ProgressBar variant="info" now={30} /> <p>PHP</p>
            <ProgressBar  variant="info" now={20} /><p>JavaScript, React, Bootstrap</p>
      </div>
      <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4">
            <p className="pb-4 font-weight-bold">Kita programinė įranga</p>
            <ProgressBar variant="warning" now={30} /><p>SPSS</p>
            <ProgressBar variant="warning" now={80} /> <p>Microsoft Office</p>
            <ProgressBar variant="warning" now={80} />  <p>Ulead PhotoImpact, Inkscape</p>
            <ProgressBar variant="warning" now={80} /> <p>SERVE</p>
            <ProgressBar  variant="warning" now={70} /><p>MS Visio</p>
      </div>
       
            <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4">
            <p className="pb-4 pt-4 font-weight-bold">Operacinės sistemos</p>
            <ProgressBar variant="info" now={70} /><p>Windows</p>
            <ProgressBar variant="info" now={30} /> <p>Linux</p>
      </div>
      <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4 pt-4">
            <p className="pb-4 font-weight-bold">Projektavimo sistemos</p>
            <ProgressBar variant="warning" now={60} /><p>AutoCad</p>
            <ProgressBar  variant="warning" now={100} />  <p>Realtime Landscaping Architect</p>
      </div>
      <div className="col-12 col-sm-6 col-md-6 col-lg-4 .col-xl-4 pt-4 pb-5">
            <p className="pb-4 font-weight-bold">Žymėjimo kalbos</p>
            <ProgressBar variant="success" now={70} /><p>CSS</p>
            <ProgressBar variant="success" now={70}  />  <p>HTML</p>
      </div>
      </div>
      </div>
    )
}
export default BlockThree